import { render } from "./PrintTransferButton.vue?vue&type=template&id=4043dca6"
import script from "./PrintTransferButton.vue?vue&type=script&lang=js"
export * from "./PrintTransferButton.vue?vue&type=script&lang=js"
script.render = render

export default script